import { createAsyncThunk, current } from '@reduxjs/toolkit';

// types

// functions

//	--------------------------------------------------------------------------
//
//	R E D U X   S T A T E   M A N A G E M E N T
//
//	--------------------------------------------------------------------------

import { AppDispatch, RootState, store } from '../../app/store';

// import state definition and functions.
import { handleEvent } from '../../app-actions';

import { setAPIStatuses } from './home-slice';

//	--------------------------------------------------------------------------
//
//	T Y P E S
//
//	--------------------------------------------------------------------------

import {
  createAppAsyncThunk,
  NavigateEventContext,
  SiteStorageArea,
  StorageArea,
} from '../../utils/types';
import {
  Event,
  EventType,
  EventTarget,
  MoveDataToStorage,
  AddCollectionEvent,
  APIStatusParams,
} from '../../utils/events';

//	--------------------------------------------------------------------------
//
//	C O N S T A N T S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	F U N C T I O N S
//
//	--------------------------------------------------------------------------

import {
  refreshCanfarServices,
  refreshSRCNetServices,
} from '../interactive-sessions/interactive-sessions-actions';

//  ------------------------------------------------------------
//
//  Handle actions on the home page.
//
//  ------------------------------------------------------------

export const eventHandler = createAppAsyncThunk(
  'home/homeEventHandler',
  async (args: { event: Event; ctx?: NavigateEventContext }, thunkAPI) => {
    //
    switch (args.event.eventType) {
      case EventType.FETCH_COMPUTE_SESSIONS:
        thunkAPI.dispatch(refreshSRCNetServices());
        thunkAPI.dispatch(refreshCanfarServices({}));
        break;

      case EventType.API_STATUS_UPDATE:
        const params = args.event.parameters as APIStatusParams;
        await _updateAPIStatuses(params, thunkAPI.dispatch, thunkAPI.getState);
        break;
    }
    //
  },
); // eventHandler

//  ------------------------------------------------------------
//
//  Updates global API statuses with supplied parameters.
//
//  ------------------------------------------------------------

async function _updateAPIStatuses(
  params: APIStatusParams,
  dispatch: AppDispatch,
  getState: () => RootState,
  signal?: AbortSignal,
) {
  //
  const stateFetch = getState();
  const currentStatuses = stateFetch.home.sAPIStatuses;

  const statusMap = new Map(
    params.apiStatuses.map((statusItem) => [statusItem.api, statusItem.status]),
  );

  const updatedStatuses = currentStatuses.map((statusItem) => {
    const newStatusItem = statusMap.get(statusItem.api);

    return newStatusItem !== undefined
      ? { ...statusItem, status: newStatusItem }
      : statusItem;
  });

  dispatch(setAPIStatuses(updatedStatuses));
  //
} // _updateAPIStatuses
